import { User } from "@/types/userTypes";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export const AuthPrivateRoutes = () => {
  const { token }: { token: string | null } = useSelector(
    (state: { user }) => state.user
  );
  const location = useLocation();

  if (token) return <Outlet />;

  const redirect = encodeURIComponent(
    `${location.pathname}${location.search || ""}`
  );
  return <Navigate to={`/ingresar?redirect=${redirect}`} replace />;
};

export const WorkerPrivateRoutes = () => {
  const { user: me }: { user: User } = useSelector(
    (state: { user }) => state.user
  );
  return me.type === "worker" ? <Outlet /> : <Navigate to="/" />;
};

export const ClientPrivateRoutes = () => {
  const { user: me }: { user: User } = useSelector(
    (state: { user }) => state.user
  );
  return me.type === "user" ? <Outlet /> : <Navigate to="/" />;
};
